const findByDealId = dealDetails => Object.keys(dealDetails).find(dealId => {
  const deal = dealDetails[dealId];
  const {
    testDrive
  } = deal;
  const {
    testDriveNotified = false,
    scheduledDate = null,
    testDriveCompleted = false
  } = testDrive;
  return !scheduledDate && !testDriveCompleted && !testDriveNotified;
});
const remindTestDrive = dealDetails => dealDetails[findByDealId(dealDetails)];
export { remindTestDrive as default };
